import type { ShippingClient, TypedClient } from '@platform/openapi';
import { useState } from 'react';
import { defaultDayRangeOf, type DayRange } from '../report-period.ts';
import type { Comparison, ProductFilter } from './performance.ts';
import type { ChosenDays } from './widgets/DashboardFilters.tsx';
import type { WidgetContext } from './widgets/widget-types.ts';

export type DashboardProps = {
  api: TypedClient;
  shipping: ShippingClient;
  company: string | null;
  productFilter: ProductFilter;
  days: ChosenDays;
  comparison: Comparison;
  viewId: string | null;
  onCompanyChange: (company: string | null) => void;
  onProductFilterChange: (filter: ProductFilter) => void;
  onDaysChange: (days: ChosenDays) => void;
  onComparisonChange: (comparison: Comparison) => void;
  onViewChange: (viewId: string | null) => void;
  onDirtyChange?: (dirty: boolean) => void;
};

export const useWidgetContext = ({
  api,
  shipping,
  company,
  productFilter,
  days,
  comparison,
}: DashboardProps): WidgetContext => {
  const [fallback] = useState(() => defaultDayRangeOf(new Date()));
  const range: DayRange = { fromDay: days.from ?? fallback.fromDay, toDay: days.to ?? fallback.toDay };
  return { api, shipping, range, company, productFilter, comparison };
};
